import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent, UserManagementComponent } from './admin';
import { HomeComponent } from '../app/home/home.component';
import { NotFoundComponent } from '../app/not-found/not-found.component';
import { LayoutComponent } from './_shared/layout/layout.component';
import { AssignUserOnBehalfComponent } from './user/assign-user-on-behalf/assign-user-on-behalf.component';
import { AddVowdComponent } from './user/add-vowd/add-vowd.component';
import { EnterVowdComponent } from './user/enter-vowd/enter-vowd.component';
import { SetComplianceComponent } from './admin/set-compliance/set-compliance.component';

import { VowdCommentComponent } from './user/vowd-comment/vowd-comment.component';
import { DropAnalysisComponent } from './reports/drop-analysis/drop-analysis.component';
import { SetThresholdComponent } from './admin/set-threshold/set-threshold.component';
import { AssignContractComponent } from './admin/assign-contract/assign-contract.component';
import { SearchComponent } from './reports/search/search.component';
import { OpexAccrualReportComponent } from './reports/opex-accrual-report/opex-accrual-report.component';
import { AgingReportComponent } from './reports/aging-report/aging-report.component';
import { DropCommentReportComponent } from './reports/drop-comment-report/drop-comment-report.component';
import { LogReportComponent } from './reports/log-report/log-report.component';
import { VowdReportComponent } from './reports/vowd-report/vowd-report.component';
import { SetApproveddateComponent } from './admin/set-approveddate/set-approveddate.component';
import { ErrorComponent } from './error/error.component';
import { DropAnalysisContractComponent } from './reports/drop-analysis-contract/drop-analysis-contract.component';
import { PaymentDetailReportsComponent } from './reports/payment-detail-reports/payment-detail-reports.component';


const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'Home', component: HomeComponent },
      { path: 'NotFound', component: NotFoundComponent},
      { path: 'admin', component: AdminComponent, },
      { path: 'AssignUser', component: AssignUserOnBehalfComponent,  },
      { path: 'AddVowd', component: AddVowdComponent, },
      { path: 'EnterVowd', component: EnterVowdComponent },
      { path: 'AdminUserMgmt', component: UserManagementComponent,  },
      {path: 'ContractdropAnalysis', component: DropAnalysisContractComponent,  },
      { path: 'SetCompliance', component: SetComplianceComponent, },
      { path: 'VowdComment', component: VowdCommentComponent },
      { path: 'SetThreshold', component: SetThresholdComponent },
      { path: 'EnterVowdAdmin', component: EnterVowdComponent },
      { path: 'dropanalysis', component: DropAnalysisComponent },
      { path: 'Search', component: SearchComponent },
      { path: 'OpexAccrual', component: OpexAccrualReportComponent },
      { path: 'AgingReport', component: AgingReportComponent },
      { path: 'DropComment', component: DropCommentReportComponent, },
      { path: 'Log', component: LogReportComponent, },
      { path: 'VOWDReport', component: VowdReportComponent, },
      { path: 'SetApprovedDate', component: SetApproveddateComponent, },
      { path: 'AssignContract', component: AssignContractComponent, },
      { path: 'Error', component: ErrorComponent, },    
      { path: 'PaymentDetails', component: PaymentDetailReportsComponent,},  
 //otherwise redirect to home
     { path: '**', redirectTo: '' }
    ], 
   
  }
];
@NgModule({
 
  imports: [RouterModule.forRoot(routes,{ useHash: false }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
